import { defineStore } from 'pinia'
import { login, getUserInfo } from '@/api/portal/user'
import { ElMessage } from 'element-plus'

export const useUserStore = defineStore('user', {
  state: () => ({
    token: localStorage.getItem('token') || '',
    userInfo: JSON.parse(localStorage.getItem('userInfo') || '{}')
  }),

  getters: {
    isLoggedIn: (state) => !!state.token && !!localStorage.getItem('token'),
    username: (state) => state.userInfo.name || '',
    avatar: (state) => state.userInfo.headPortrait || '',
    mobile: (state) => state.userInfo.mobilePhone || '',
    expireTime: (state) => state.userInfo.expireTime || '',
    totalAmount: (state) => state.userInfo.totalAmount || 0
  },

  actions: {
    // 登录
    async login(identifier, password) {
      try {
        const res = await login({ identifier, password })
        if (res.code === 0) {
          // 保存token
          this.token = res.token
          localStorage.setItem('token', res.token)
          
          // 保存用户信息
          this.userInfo = res.userInfo
          localStorage.setItem('userInfo', JSON.stringify(res.userInfo))
          
          ElMessage.success('登录成功')
          return true
        }
        return false
      } catch (error) {
        // 错误消息已在request拦截器中显示，这里不再重复显示
        return false
      }
    },

    // 获取用户信息
    async getUserInfo() {
      try {
        const res = await getUserInfo()
        if (res.code === 0) {
          this.userInfo = res.userInfo
          localStorage.setItem('userInfo', JSON.stringify(res.userInfo))
          return res.userInfo
        }
        return null
      } catch (error) {
        // 错误消息已在request拦截器中显示，这里不再重复显示
        return null
      }
    },

    // 退出登录
    logout() {
      this.token = ''
      this.userInfo = {}
      localStorage.removeItem('token')
      localStorage.removeItem('userInfo')
    }
  }
})
